import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { FiEdit, FiFileText, FiDollarSign, FiImage } from "react-icons/fi";
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  Divider,
  Backdrop,
  CircularProgress,
  Button,
  IconButton,
  CardActions,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField
} from "@mui/material";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import { styled } from "@mui/material/styles";
import { vendorApi } from "../../api/api";
import { useRef } from "react";
import { Line } from "react-chartjs-2";
import PropertyDocuments from "../../Pages/Propertys/propertydocuments";
import PropertyGallery from "../../Pages/Propertys/propertygallery";
import { useSelector } from "react-redux";
import ExtraDataDetails from "../common/ExtraDetailsVilla";
import DeleteIcon from '@mui/icons-material/Delete';
import UploadIcon from "@mui/icons-material/Upload";
import AddIcon from "@mui/icons-material/Add";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";


// Styled component for SpeedDial button
const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
  position: "fixed",
  bottom: theme.spacing(2),
  right: theme.spacing(2),
}));

const ViewPropertyBody = () => {
  const role = useSelector((state) => state.user.role);
  const location = useLocation();
  const navigate = useNavigate();
  const {
    PropertyId,
    PropertyName,
    City,
    Address,
    ProjectName,
    PropertyType,
    SizeInSqFt,
    UnitPrice,
    percentagevalue,
    sqftamount,
    IconUrl,
    Status,
   
  } = location.state || {};


  const [propertyData, setPropertyData] = useState([]);
  const [loading, setLoading] = useState(true)
  const [fileUrls, setFileUrls] = useState([]);
  const [imageData, setImageData] = useState();
  const [propertVideo, setpropertVideo] = useState([]);
  const [propertContact, setpropertContact] = useState(null);
  const videoInputRef = useRef(null);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [selectedVideos, setSelectedVideos] = useState(null);

  const [openEditContact, setOpenEditContact] = useState(false);
  const [contactForm, setContactForm] = useState({
    owner_name: "",
    owner_mobile: "",
    owner_email: "",
    owner_address: "",
    reference_name: "",
    reference_mobile: "",
  });
  const [isEditMode, setIsEditMode] = useState(false);


  const actions = useMemo(
    () => [
     {
  name: "Edit",
  icon: <FiEdit />,
  onClick: () => {
    if (propertyData?.propertyData?.PropertyType === "Property") {
      navigate("/property/editProperty", {
        state: {
          PropertyId,
          PropertyName,
          City,
          Address,
          ProjectName,
          Description: propertyData?.propertyData?.Description,
          PropertyType,
          SizeInSqFt,
          UnitPrice,
          IconUrl,
          percentagevalue,
          sqftamount,
          Status,

          // ✅ ADD THIS
          videos: propertVideo.map(v => v.video_url),
        },
      });


          } else if (
            propertyData?.propertyData?.PropertyType === "Individual Villa"
          ) {
            navigate("/villa/editVillaDetails", {
              state: {
                propertyData: propertyData.propertyData,
                PropertyType: PropertyType,
                percentagevalue: percentagevalue,
                sqftamount: sqftamount
              },
            });
          }
        },
      },
      {
        name: "Images",
        icon: <FiImage />,
        onClick: () => {
          navigate("/property/AddImages", {
            state: {
              PropertyId,
              PropertyName,
              City,
              Address,
              ProjectName,
              PropertyType,
              SizeInSqFt,
              UnitPrice,
              IconUrl,
            },
          });
        },
      },
      {
        name: "Document",
        icon: <FiFileText />,
        onClick: () => {
          navigate("/property/addDocument", {
            state: {
              PropertyName,
              City,
              Address,
              ProjectName,
              PropertyType,
              SizeInSqFt,
              UnitPrice,
              PropertyId,
            },
          });
        },
      },
      {
        name: "Market Price",
        icon: <FiDollarSign />,
        onClick: () => {
          if (propertyData?.propertyData?.PropertyType === "Individual Villa") {
            navigate("/updatePropertyPrice", {
              state: {
                propertyData: [
                  {
                    PropertyName: propertyData?.propertyData?.PropertyName,
                    City: propertyData?.propertyData?.Address,
                    Id: propertyData?.propertyData?.Pid,
                    MarketPrice: propertyData?.propertyData?.CurrentValue,
                    PropertyType: PropertyType,
                  },
                ],
              },
            });
          } else {
            navigate("/property/marketPrice", {
              state: {
                PropertyName,
                City,
                Address,
                ProjectName,
                PropertyType,
                SizeInSqFt,
                UnitPrice,
                PropertyId,
              },
            });
          }
        },
      },
    ],
    [
      navigate,
      PropertyId,
      PropertyName,
      City,
      Address,
      ProjectName,
      PropertyType,
      SizeInSqFt,
      UnitPrice,
      propertyData,
    ]
  );

  useEffect(() => {
    const getProperties = async () => {
      try {
        setLoading(true);

        const [propertyresponse, imageresponse] =
          await Promise.all([
            vendorApi.getPropertyById(PropertyId),
            vendorApi.getPropertyImages(PropertyId),

          ]);

        setPropertyData(propertyresponse.data);
        setImageData(imageresponse.data);


      } catch (error) {
        console.error("Error fetching property data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (PropertyId) {
      getProperties();
    }
  }, [PropertyId]);

  useEffect(() => {
    const getProperties = async () => {
      let type = null;

      switch (propertyData?.propertyData?.PropertyType) {
        case "Property": type = 2; break;
        case "Project": type = 1; break;
        case "Individual Villa": type = 4; break;
        case "Apartment": type = 3; break;
        default: return;
      }
     
      const data = {
        type: type,
        reference_id: PropertyId || propertyData?.propertyData?.Pid,
      };

      try {
    
        setLoading(true);

        const [propervideos, propertycontact] =
          await Promise.all([
            vendorApi.getPropertyVideos(data),
            vendorApi.getPropertyContactDetails(data),

          ]);
     
        setpropertVideo(propervideos.data.data);
        setpropertContact(propertycontact.data.data)
      } catch (error) {
        console.error("Error fetching property videos:", error);
      } finally {
        setLoading(false);
      }
    };
    getProperties();

  }, [propertyData]);

  const handleAddVideo = () => {
    setOpenVideoModal(true);
  };
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedVideos(file);
    }
  };


  const handleUploadVideos = async () => {
   
    if (!selectedVideos) return;

    let type = null;

    switch (propertyData?.propertyData?.PropertyType) {
      case "Property": type = 2; break;
      case "Project": type = 1; break;
      case "Individual Villa": type = 4; break;
      case "Apartment": type = 3; break;
      default: return;
    }

    const formData = new FormData();
    formData.append("type", type);
    formData.append("reference_id", propertyData.propertyData.Pid);
    formData.append("video", selectedVideos); // ✅ IMPORTANT

    // Debug (optional)
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }
    
    try {
      await vendorApi.addpropertyvideos(formData);
      setOpenVideoModal(false);
      setSelectedVideos(null);
      alert("Video Save Successfully");
      navigate(-1)
    } catch (error) {
      console.error("Upload failed", error);
    }
  };

  const getPropertyTypeNumber = () => {
    switch (propertyData?.propertyData?.PropertyType) {
      case "Property": return 2;
      case "Project": return 1;
      case "Apartment": return 3;
      case "Individual Villa": return 4;
      default: return null;
    }
  };
 

  const handleDeleteVideo = async (id) => {
    const type = getPropertyTypeNumber();

    if (!window.confirm("Are you sure you want to delete this video?")) return;

    try {
     
      await vendorApi.deletepropertyvideo({
        id: id,
        type: type,
        reference_id: propertyData.propertyData.Pid
      });

      alert("Video deleted successfully");
      navigate(-1)

    } catch (error) {
      console.error("Delete failed", error);
    }
  };
  const handleAddContact = async () => {
    const type = getPropertyTypeNumber();

    if (!type) {
      alert("Invalid property type");
      return;
    }

    const payload = {
      property_id: propertyData.propertyData.Pid, // ✅ correct ID
      type: type,                                 // ✅ REQUIRED
      owner_name: contactForm.owner_name,
      owner_mobile: contactForm.owner_mobile,
      owner_email: contactForm.owner_email,
      owner_address: contactForm.owner_address,
      reference_name: contactForm.reference_name,
      reference_mobile: contactForm.reference_mobile,
    };

    try {
  
      const response = await vendorApi.addPropertyContactDetails(payload);

      alert("Contact added successfully");

      // ✅ Update UI with backend response
      setpropertContact(response.data.data);

      setOpenEditContact(false);
      setIsEditMode(false);

    } catch (error) {
      console.error("Add contact failed", error);
      alert("Failed to add contact");
    }
  };


  const handleUpdateContact = async () => {
    const type = getPropertyTypeNumber();

    if (!type) {
      alert("Invalid property type");
      return;
    }

    const payload = {
      property_id: propertyData.propertyData.Pid, // ✅ REQUIRED
      type: type,                                 // ✅ REQUIRED

      owner_name: contactForm.owner_name,
      owner_mobile: contactForm.owner_mobile,
      owner_email: contactForm.owner_email,
      owner_address: contactForm.owner_address,

      reference_name: contactForm.reference_name,
      reference_mobile: contactForm.reference_mobile,
    };

    try {
  

      const response = await vendorApi.editecontactdetails(payload);

      alert("Contact updated successfully");

      // ✅ Always trust backend response
      setpropertContact(response.data.data);

      setOpenEditContact(false);
      setIsEditMode(false);

    } catch (error) {
      console.error("Update failed", error);
      alert("Failed to update contact");
    }
  };


  const chartData = {
    labels: propertyData.marketRange?.labels || [],
    datasets: [
      {
        label: "Market Value",
        data: propertyData.marketRange?.data?.map(Number) || [],
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  useEffect(() => {
    if (propertyData?.propertyData?.documents) {
      const urls = propertyData.propertyData.documents.map(
        (doc) => doc.DocumentURL
      );
      setFileUrls(urls);
    }
  }, [propertyData]);

  if (loading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  const handleDelete = async (data) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this property?"
    );


    if (!confirmDelete) return; // user clicked Cancel

    let propertyType = null;

    if (data.PropertyType === "Property") propertyType = 2;
    else if (data.PropertyType === "Project") propertyType = 1;
    else if (data.PropertyType === "Apartment") propertyType = 3;
    else if (data.PropertyType === "Individual Villa") propertyType = 4;

    if (!propertyType) {
      console.error("Invalid PropertyType", data.PropertyType);
      return;
    }

    const deleteItem = {
      PropertyId: Number(data.Pid),
      PropertyType: Number(propertyType),
    };

    try {
   
      
      const response = await vendorApi.deteleProperty(deleteItem);
      alert("Property deleted successfully");


    } catch (error) {
      alert("Failed to delete property");
      console.error("Delete failed", error);
    }
  };


  const type = propertyData?.propertyData?.PropertyType;

 

  const getYoutubeEmbedUrl = (url) => {
  if (!url) return null;

  const match = url.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/ 
  );

  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
};



  return (
    <Container
      sx={{
        py: { xs: 2, md: 5 },
        px: { xs: 1, sm: 2, md: 3 },
        width: "95%",
      }}
    >
      <Box
        sx={{
          p: { xs: 2, md: 4 },
          borderRadius: 2,
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          backgroundColor: "#fff",
        }}
      >
        {/* Breadcrumb */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            mb: 4,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: "#13216e",
              fontWeight: 600,
              fontSize: { xs: "20px", md: "24px" },
            }}
          >
            View Property
          </Typography>
          {role === "admin" && (
            <Box sx={{ fontSize: { xs: "14px", md: "18px" } }}>
              <Link
                to="/home"
                style={{ textDecoration: "none", color: "#4e0dff" }}
              >
                Home
              </Link>
              <BsArrowRight style={{ margin: "0 8px", color: "#4e0dff" }} />
              <Link
                to="/property"
                style={{ textDecoration: "none", color: "#4e0dff" }}
              >
                View Property
              </Link>
            </Box>
          )}
        </Box>

        {/* SpeedDial */}
        {role !== "legalteam" && (
          <StyledSpeedDial ariaLabel="SpeedDial" icon={<SpeedDialIcon />}>
            {actions.map((action) => (
              <SpeedDialAction
                key={action.name}
                icon={action.icon}
                tooltipTitle={action.name}
                onClick={action.onClick}
              />
            ))}
          </StyledSpeedDial>
        )}

        {/* Property Info + Chart */}
        <Grid container spacing={2}>
          {/* Property Details */}
          <Grid item xs={12} md={6}>
            <Card sx={{ border: "1px solid lightgray", borderRadius: "10px" }}>
              <CardContent>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography
                    variant="h6"
                    sx={{ color: "black", fontWeight: 600, fontSize: "20px" }}
                  >
                    {propertyData?.propertyData?.PropertyName}
                  </Typography>

                  <Box sx={{ display: "flex", gap: 2 }}>
                    {/* Delete Button */}
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      startIcon={<DeleteIcon />}
                      onClick={() => handleDelete(propertyData?.propertyData)}
                      sx={{
                        textTransform: 'none',
                        borderRadius: '8px',
                        '&:hover': {
                          backgroundColor: 'error.light',
                          color: 'error.contrastText'
                        }
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>
                <Typography sx={{ color: "black", fontSize: "16px" }}>
                  {propertyData?.propertyData?.Address}
                </Typography>
                <Typography
                  sx={{
                    color: "gray",
                    fontSize: "14px",
                    ml: 1,
                  }}
                >
                  {propertyData?.propertyData?.City}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    mt: 2,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Property Type
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="medium"
                      color="blue"
                    >
                      {propertyData?.propertyData?.PropertyType || "N/A"}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Size (In SqFt)
                    </Typography>
                    <Typography variant="body1" fontWeight="medium">
                      {propertyData?.propertyData?.SizeInSqFt || "N/A"}
                    </Typography>
                  </Box>

                  {(type === "Property" || type === "Project") && (
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography variant="subtitle2" color="text.secondary">
                        SqFt Price
                      </Typography>
                      <Typography
                        variant="body1"
                        fontWeight="medium"
                        color="primary"
                      >
                        ₹ {propertyData?.propertyData?.UnitPrice || "N/A"}
                      </Typography>
                    </Box>
                  )}

                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Property Value
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="success.main"
                    >
                      ₹ {propertyData?.propertyData?.CurrentValue || "N/A"}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Facing
                    </Typography>
                    <Typography variant="body1" fontWeight="bold" color="blue">
                      {propertyData?.propertyData?.Facing || "N/A"}
                    </Typography>
                  </Box>

                  {sqftamount === null ? (
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Commission ( in Percentage )
                      </Typography>
                      <Typography variant="body1" fontWeight="medium" color="primary">
                        {percentagevalue}%
                      </Typography>
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography variant="subtitle2" color="text.secondary">
                        Commission (Per SqFt)
                      </Typography>
                      <Typography variant="body1" fontWeight="medium" color="primary">
                        ₹ {sqftamount}
                      </Typography>
                    </Box>
                  )}

                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Market Value Chart */}
          <Grid item xs={12} md={6}>
            <Card sx={{ border: "1px solid lightgray", borderRadius: "10px" }}>
              <CardContent>
                <Line
                  data={chartData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: { display: true, position: "top" },
                    },
                  }}
                  height={300}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* <Divider sx={{ my: 4 }} /> */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Description
          </Typography>
  {propertyData?.propertyData?.Description ? (
          <ReactQuill
  value={propertyData?.propertyData?.Description}
  readOnly
  theme="bubble"
/>

         
          ) : (
            <Typography color="text.secondary">
              No description available
            </Typography>
          )}
        </Box>



        {/* Extra Details */}
        <ExtraDataDetails extraData={propertyData?.propertyData?.ExtraData} />
        {/* <Divider sx={{ my: 4 }} /> */}

        <Box sx={{ mt: 4 }}>
          {/* Header Row */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: "#13216e" }}
            >
              Contact Details
            </Typography>

            {/* Action Buttons - Show Add if no data, Edit if data exists */}
            <Box sx={{ display: "flex", gap: 1 }}>
              {!propertContact ? (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setIsEditMode(false);
                    setContactForm({
                      owner_name: "",
                      owner_mobile: "",
                      owner_email: "",
                      owner_address: "",
                      reference_name: "",
                      reference_mobile: "",
                    });
                    setOpenEditContact(true);
                  }}
                >
                  Add Contact
                </Button>

              ) : (
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<FiEdit />}
                  onClick={() => {
                    setIsEditMode(true);
                    setContactForm(propertContact); // preload data
                    setOpenEditContact(true);
                  }}
                >
                  Edit Contact
                </Button>


              )}
            </Box>
          </Box>

          {propertContact ? (
            <Grid container spacing={2}>
              {/* Owner Details */}
              <Grid item xs={12} md={6}>
                <Card
                  sx={{
                    border: '1px solid #e0e0e0',
                    borderRadius: 1,
                    p: 2
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                    Owner Information
                  </Typography>

                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        Name
                      </Typography>
                      <Typography variant="body1">
                        {propertContact.owner_name || "N/A"}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        Mobile
                      </Typography>
                      <Typography variant="body1">
                        {propertContact.owner_mobile || "N/A"}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        Email
                      </Typography>
                      <Typography variant="body1">
                        {propertContact.owner_email || "N/A"}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        Address
                      </Typography>
                      <Typography variant="body1">
                        {propertContact.owner_address || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>

            </Grid>
          ) : (
            <Card
              sx={{
                p: 4,
                textAlign: 'center',
                border: '1px dashed #ccc',
                borderRadius: 1,
                backgroundColor: '#fafafa'
              }}
            >
              <Typography color="text.secondary" sx={{ mb: 2 }}>
                No contact details available
              </Typography>
              <Button
                variant="outlined"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => {
                  setIsEditMode(false);
                  setContactForm({
                    owner_name: "",
                    owner_mobile: "",
                    owner_email: "",
                    owner_address: "",
                    reference_name: "",
                    reference_mobile: "",
                  });
                  setOpenEditContact(true);
                }}
              >
                Add Contact Details
              </Button>
            </Card>
          )}
        </Box>
        <Divider sx={{ my: 4 }} />

        {/* Documents */}
        <PropertyDocuments
          documentData={propertyData?.propertyData?.documents}
          type={2}
        />

        <Divider sx={{ my: 4 }} />

        {/* Gallery */}
        <PropertyGallery imageData={imageData} type={2} />
        <Box sx={{ mt: 4 }}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Property Videos
            </Typography>

            {/* <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAddVideo}
            >
              Add Video
            </Button> */}

          </Box>
          <Dialog open={openVideoModal} onClose={() => setOpenVideoModal(false)} fullWidth maxWidth="sm">
            <DialogTitle>Upload Property Video</DialogTitle>

            <DialogContent>
              <Box mt={2}>
                <input
                  type="file"
                  accept="video/mp4,video/webm,video/quicktime"
                  onChange={handleVideoChange}
                />

                {selectedVideos && (
                  <Box mt={1}>
                    <strong>Selected file:</strong> {selectedVideos.name}
                  </Box>
                )}
              </Box>
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setOpenVideoModal(false)}>
                Cancel
              </Button>

              <Button
                variant="contained"
                startIcon={<UploadIcon />}
                onClick={handleUploadVideos}
                disabled={!selectedVideos}   // ✅ FIX
              >
                Upload
              </Button>
            </DialogActions>
          </Dialog>

        
              {/* Video List */}
{propertVideo.length > 0 ? (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: "1fr",
        sm: "repeat(2, 1fr)",
        md: "repeat(3, 1fr)",
      },
      gap: 3,
    }}
  >
    {propertVideo.map((video) => {
      const embedUrl = getYoutubeEmbedUrl(video.video_url);
      if (!embedUrl) return null;

      return (
        <Card
          key={video.id}
          sx={{
            borderRadius: 3,
            boxShadow: 3,
            overflow: "hidden",
            transition: "0.3s",
            "&:hover": {
              boxShadow: 6,
              transform: "translateY(-4px)",
            },
          }}
        >
          {/* YouTube iframe */}
          <iframe
            src={embedUrl}
            width="100%"
            height="200"
            style={{ border: "none" }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={`property-video-${video.id}`}
          />

         
        </Card>
      );
    })}
  </Box>
) : (
  <Typography color="text.secondary">No videos available</Typography>
)}
            </Box>
          


      </Box>
      <Dialog
        open={openEditContact}
        onClose={() => setOpenEditContact(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {isEditMode ? "Edit Contact Details" : "Add Contact Details"}
        </DialogTitle>


        <DialogContent dividers>
          <Grid container spacing={2} mt={1}>

            <Grid item xs={12}>
              <Typography fontWeight={600}>Owner Information</Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Name"
                fullWidth
                value={contactForm.owner_name || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, owner_name: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Mobile"
                fullWidth
                value={contactForm.owner_mobile || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, owner_mobile: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Email"
                fullWidth
                value={contactForm.owner_email || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, owner_email: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Address"
                fullWidth
                multiline
                rows={3}
                value={contactForm.owner_address || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, owner_address: e.target.value })
                }
              />
            </Grid>

            {/* <Grid item xs={12} mt={2}>
              <Typography fontWeight={600}>Reference Information</Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Reference Name"
                fullWidth
                value={contactForm.reference_name || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, reference_name: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Reference Mobile"
                fullWidth
                value={contactForm.reference_mobile || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, reference_mobile: e.target.value })
                }
              />
            </Grid> */}

          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenEditContact(false)}>
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={isEditMode ? handleUpdateContact : handleAddContact}
          >
            {isEditMode ? "Update" : "Save"}
          </Button>

        </DialogActions>
      </Dialog>

    </Container>
  );
};

export default ViewPropertyBody;
